const themeConfig = {
    colors: {
        default: {
            primary: '#008AC5',
            tertiary: '#008AC5',
        },
        hover: {
            primary: '#078eca',
            tertiary: '#078eca',
        },
    },
};

export default themeConfig;
